<template>
  <div style="text-align: left">
    <article>
      <section>
        <div class="container mt-5">
          <div class="mb-3">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/resources' }"
                >Resources</el-breadcrumb-item
              >
              <el-breadcrumb-item>Edit Resource</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <h1 class="mb-4" style="font-size: 1.1em; font-weight: 600">
            Edit Resource
          </h1>
          <div v-loading="isUploadingFile || isLoading">
            <el-form
              :model="resourceForm"
              :rules="resourceRules"
              ref="resourceForm"
              class="demo-resourceForm"
            >
              <div class="row">
                <div class="col-md-6">
                  <label class="mt-3 mb-2">Title</label>
                  <el-form-item prop="title">
                    <el-input
                      v-model="resourceForm.title"
                      placeholder="Resource Title"
                    ></el-input>
                  </el-form-item>
                </div>
                <div class="col-md-6">
                  <label class="mt-3 mb-2">Brief Description</label>
                  <el-form-item prop="description">
                    <el-input
                      v-model="resourceForm.description"
                      type="textarea"
                      :rows="2"
                      placeholder="Brief description of the resource"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div
                class="row"
                style="border: 2px dotted grey; padding: 10px; margin-top: 20px"
              >
                <div class="col-md-6">
                  <label class="mt-3 mb-2">Resource Image</label><br />
                  <el-form-item>
                    <el-upload
                      class="upload-demo"
                      drag
                      action="''"
                      :on-change="handleImagePreview"
                      :on-remove="handleImageRemove"
                      :file-list="imageFileLists"
                      :auto-upload="false"
                      :multiple="false"
                      accept="image/*"
                    >
                      <div v-if="!isUploadingFile">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                          Drop image here or <em>click to upload</em>
                        </div>
                      </div>
                      <div v-else>
                        <el-progress
                          v-if="imageUploadingProgress != 100"
                          type="circle"
                          :color="progressColors"
                          :percentage="imageUploadingProgress"
                          :width="80"
                          :stroke-width="4"
                        ></el-progress>
                        <el-progress
                          v-else
                          type="circle"
                          :percentage="100"
                          status="success"
                          :width="80"
                          :stroke-width="4"
                        ></el-progress>
                        <div
                          style="font-size: 0.8em; color: rgba(0, 0, 0, 0.8)"
                        >
                          {{
                            imageUploadingProgress == 100
                              ? "Uploaded"
                              : "Uploading..."
                          }}
                        </div>
                      </div>
                    </el-upload>
                  </el-form-item>
                </div>
                <div class="col-md-6">
                  <img
                    v-if="imagePreviewUrl"
                    :src="this.imagePreviewUrl"
                    style="
                      width: 85%;
                      height: auto;
                      max-height: 400px;
                      object-fit: cover;
                      border-radius: 8px;
                      display: block;
                      margin: 0 auto;
                    "
                  />
                </div>
              </div>

              <!-- Resource Type Display/Selection -->
              <div class="row" style="margin-top: 20px;">
                <div class="col-md-12">
                  <label class="mt-3 mb-2">Resource Type <span style="color: red;">*</span></label>
                  <el-radio-group v-model="resourceType" @change="onResourceTypeChange">
                    <el-radio label="document">
                      <i class="el-icon-document"></i> Document (PDF, Word, Excel, etc.)
                    </el-radio>
                    <el-radio label="video">
                      <i class="el-icon-video-camera"></i> Video (MP4, WebM, MOV, etc.)
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>

              <!-- Document Upload Section -->
              <div
                v-if="resourceType === 'document'"
                class="row"
                style="border: 2px dotted grey; padding: 10px; margin-top: 20px"
              >
                <div class="col-md-6">
                  <label class="mt-3 mb-2">File Attachment (Document)</label><br />
                  <el-form-item>
                    <el-upload
                      class="upload-demo"
                      drag
                      action="''"
                      :on-change="handleFilePreview"
                      :on-remove="handleFileRemove"
                      :file-list="docFileLists"
                      :auto-upload="false"
                      :multiple="false"
                    >
                      <div>
                        <i class="el-icon-document"></i>
                        <div class="el-upload__text">
                          Drop document here or <em>click to upload</em>
                        </div>
                      </div>
                    </el-upload>
                  </el-form-item>
                </div>
                <div class="col-md-6">
                  <div v-if="selectedDocFile || currentFileUrl" style="padding: 20px;">
                    <i class="el-icon-document" style="font-size: 48px; color: #409EFF;"></i>
                    <p v-if="selectedDocFile"><strong>New File:</strong> {{ selectedDocFile.name }}</p>
                    <p v-else-if="currentFileUrl"><strong>Current File:</strong> <a :href="currentFileUrl" target="_blank">Download</a></p>
                    <p v-if="selectedDocFile"><strong>Size:</strong> {{ formatFileSize(selectedDocFile.size) }}</p>
                  </div>
                </div>
              </div>

              <!-- Video Upload Section -->
              <div
                v-if="resourceType === 'video'"
                class="row"
                style="border: 2px dotted grey; padding: 10px; margin-top: 20px"
              >
                <div class="col-md-6">
                  <label class="mt-3 mb-2">Video</label><br />
                  <el-form-item>
                    <el-upload
                      class="upload-demo"
                      drag
                      action="''"
                      :on-change="handleVideoPreview"
                      :on-remove="handleVideoRemove"
                      :file-list="videoFileLists"
                      :auto-upload="false"
                      :multiple="false"
                      accept="video/*"
                    >
                      <div>
                        <i class="el-icon-video-camera" style="font-size: 48px; color: #E6A23C;"></i>
                        <div class="el-upload__text">
                          Drop video here or <em>click to upload</em>
                        </div>
                        <div class="el-upload__tip" slot="tip" style="font-size: 11px; color: #999;">
                          MP4, WebM, MOV, AVI, etc. (Max 100MB)
                        </div>
                      </div>
                    </el-upload>
                  </el-form-item>
                </div>
                <div class="col-md-6">
                  <div v-if="videoPreviewUrl" style="padding: 20px;">
                    <video
                      :src="videoPreviewUrl"
                      controls
                      style="width: 100%; max-height: 300px; border-radius: 8px;"
                    ></video>
                    <p v-if="selectedVideoFile"><strong>New Video:</strong> {{ selectedVideoFile.name }}</p>
                    <p v-if="selectedVideoFile"><strong>Size:</strong> {{ formatFileSize(selectedVideoFile.size) }}</p>
                  </div>
                  <div v-else-if="currentVideoUrl" style="padding: 20px;">
                    <video
                      :src="currentVideoUrl"
                      controls
                      style="width: 100%; max-height: 300px; border-radius: 8px;"
                    ></video>
                    <p><strong>Current Video</strong></p>
                  </div>
                </div>
              </div>

              <hr />
              <el-form-item class="text-center">
                <el-button
                  type="primary"
                  @click="editResource('resourceForm')"
                  >Edit Resource</el-button
                >
              </el-form-item>
            </el-form>

            <div class="text-center">
              <div class="text-center">
                <small
                  >© {{ new Date().getFullYear() }} ULGA, All rights
                  reserved.</small
                >
              </div>
            </div>
          </div>
        </div>
      </section>
    </article>
  </div>
</template>


<script>
export default {
  components: {},
  data() {
    return {
      resourceType: 'document', // Will be set based on existing resource
      selectedImageFile: null,
      selectedDocFile: null,
      selectedVideoFile: null,
      imagePreviewUrl: null,
      currentFileUrl: null,
      videoPreviewUrl: null,
      currentVideoUrl: null,
      isUploadingFile: false,
      isLoading: false,
      imageUploadingProgress: 0,
      progressColors: [
        { color: "#f56c6c", percentage: 25 },
        { color: "#e6a23c", percentage: 50 },
        { color: "#1989fa", percentage: 75 },
        { color: "#6f7ad3", percentage: 100 },
      ],
      resourceForm: {
        title: "",
        description: "",
      },
      imageFileLists: [],
      docFileLists: [],
      videoFileLists: [],
      resource: {},

      resourceRules: {
        title: [
          {
            required: true,
            message: "Title is required",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "Description is required",
            trigger: "blur",
          },
        ],
      },
    };
  },

  mounted() {
    this.getOneResource();
  },

  methods: {
    handleImagePreview(file) {
      if (!file) return;
      this.selectedImageFile = file.raw;
      const reader = new FileReader();

      reader.onload = (e) => {
        this.imagePreviewUrl = e.target.result;
        this.imageFileLists = [file];
      };

      reader.onerror = (e) => {
        console.error("Error reading file:", e);
        this.$message.error("Error previewing image");
      };

      reader.readAsDataURL(file.raw);
    },

    handleImageRemove() {
      this.selectedImageFile = null;
      this.imageFileLists = [];
    },

    handleFilePreview(file) {
      if (!file) return;
      this.selectedDocFile = file.raw;
      this.docFileLists = [file];
    },

    handleFileRemove() {
      this.selectedDocFile = null;
      this.docFileLists = [];
    },

    handleVideoPreview(file) {
      if (!file) return;
      this.selectedVideoFile = file.raw;
      const reader = new FileReader();

      reader.onload = (e) => {
        this.videoPreviewUrl = e.target.result;
        this.videoFileLists = [file];
      };

      reader.onerror = (e) => {
        console.error("Error reading video file:", e);
        this.$message.error("Error previewing video");
      };

      reader.readAsDataURL(file.raw);
    },

    handleVideoRemove() {
      this.selectedVideoFile = null;
      this.videoPreviewUrl = null;
      this.videoFileLists = [];
    },

    onResourceTypeChange(newType) {
      // Clear the opposite type when switching
      if (newType === 'document') {
        this.selectedVideoFile = null;
        this.videoPreviewUrl = null;
        this.videoFileLists = [];
        this.currentVideoUrl = null;
      } else if (newType === 'video') {
        this.selectedDocFile = null;
        this.docFileLists = [];
        this.currentFileUrl = null;
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },

    beforeDestroy() {
      if (
        this.imagePreviewUrl &&
        typeof this.imagePreviewUrl === "string" &&
        this.imagePreviewUrl.startsWith("blob:")
      ) {
        URL.revokeObjectURL(this.imagePreviewUrl);
      }
    },

    async editResource(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.isUploadingFile = true;
            const formData = new FormData();
            formData.append("title", this.resourceForm.title);
            formData.append("description", this.resourceForm.description);
            
            // Image is always optional
            if (this.selectedImageFile) {
              formData.append("image", this.selectedImageFile);
            }
            
            // Add document OR video based on resource type
            if (this.resourceType === 'document' && this.selectedDocFile) {
              formData.append("file_attachment", this.selectedDocFile);
            }

            if (this.resourceType === 'video' && this.selectedVideoFile) {
              formData.append("video", this.selectedVideoFile);
            }

            formData.append("updated_by", this.$store.state.userId);

            let request = await this.$http.post(
              `home/edit_resource/${this.resource.id}`,
              formData,
              {
                onUploadProgress: (progressEvent) => {
                  this.imageUploadingProgress = +(
                    (progressEvent.loaded / progressEvent.total) *
                    100
                  ).toFixed(0);
                },
              }
            );
            if (
              request.data.success &&
              request.data.message == "RESOURCE_EDITED_SUCCESSFULLY"
            ) {
              this.$router.push({ path: "/resources" });
              this.$notify({
                title: "Success",
                message: "Resource Edited Successfully",
                type: "success",
              });
            } else if (request.data.message == "RESOURCE_NOT_FOUND") {
              this.$notify({
                title: "Not Found",
                message: "Resource not found",
                type: "error",
              });
            } else throw "UNEXPECTED_RESPONSE";
          } catch (error) {
            if (error.message == "NetworkError") {
              return this.$notify({
                title: "Connection failed",
                message: "A network error occurred please try again",
                type: "warning",
              });
            }
            this.$notify({
              title: "Update Failed",
              message: "Unable to update resource now, Please try again",
              type: "error",
            });
          } finally {
            this.isUploadingFile = false;
          }
        } else {
          return false;
        }
      });
    },

    async getOneResource() {
      this.isLoading = true;
      this.isLoadingError = false;
      try {
        let request = await this.$http.get(
          `home/get_resource/${this.$route.params.id}`
        );
        if (request.data.success) {
          this.resource = request.data.resource;
          this.resourceForm.title = request.data.resource.title;
          this.resourceForm.description = request.data.resource.description;
          this.imagePreviewUrl = request.data.resource.image;
          this.currentFileUrl = request.data.resource.file_attachment;
          this.currentVideoUrl = request.data.resource.video_url;
          
          // Determine resource type based on existing data
          if (request.data.resource.video_url) {
            this.resourceType = 'video';
          } else if (request.data.resource.file_attachment) {
            this.resourceType = 'document';
          }
        } else throw "UNEXPECTED_RESPONSE_RECEIVED";
      } catch (error) {
        this.isLoadingError = true;
        this.$notify({
          title: "Operation Failed",
          message: error,
          type: "error",
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
input[type="text"],
select,
textarea {
  width: 100%;
  padding: 10px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
  background-color: #ffffff;
  font-size: 0.9em;
}

label {
  font-size: 0.9em;
  font-weight: 600;
  color: #2a5e42;
}
</style>
